import { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { AppRoute } from '../../constants/route';
import { envConfig } from '../../config';

export const oidcConfig: AuthProviderProps = {
  authority: envConfig.REACT_APP_OUATH_URL ?? '',
  client_id: envConfig.REACT_APP_OAUTH_CLIENT_ID ?? '',
  redirect_uri: `${window.location.origin}/${AppRoute.OAUTH2_CODE}`,
  silent_redirect_uri: `${window.location.origin}/${AppRoute.OAUTH2_RENEW}`,
  post_logout_redirect_uri: `${window.location.origin}/${AppRoute.OAUTH2_LOGOUT}`,
  response_type: 'code',
  scope: 'openid',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
